import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../../query/helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  getInvoiceTemplateRowsSummary,
  InvoiceTemplateRowsQuery,
  InvoiceTemplateRowsSummary
} from "../service";

export const QUERY_INVOICE_TEMPLATE_ROWS_SUMMARY =
  "QUERY_INVOICE_TEMPLATE_ROWS_SUMMARY";

export const useQueryInvoiceTemplateRowsSummary = (
  requestQuery?: InvoiceTemplateRowsQuery,
  config?: WSQueryConfig<InvoiceTemplateRowsSummary, WSServiceError>
) =>
  useWSQuery<InvoiceTemplateRowsSummary, WSServiceError>(
    [QUERY_INVOICE_TEMPLATE_ROWS_SUMMARY, requestQuery],
    () => getInvoiceTemplateRowsSummary(requestQuery),
    config
  );
